import { COLORS } from '@client/enums';

export const generatePitchChartDataset = (data) => {
  const colors = COLORS.slice();

  return data.reverse().map((item) => {
    item.label = item.name;
    item.backgroundColor = colors.shift();

    delete item.name;
    delete item.details;

    item.datasets = [item];

    return item;
  });
};
